import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tabsListFn = /* @__PURE__ */ createRecipe('tabs-list', {}, [])

const tabsListVariantMap = {}

const tabsListVariantKeys = Object.keys(tabsListVariantMap)

export const tabsList = /* @__PURE__ */ Object.assign(memo(tabsListFn.recipeFn), {
  __recipe__: true,
  __name__: 'tabsList',
  __getCompoundVariantCss__: tabsListFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tabsListVariantKeys,
  variantMap: tabsListVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tabsListVariantKeys)
  },
  getVariantProps: tabsListFn.getVariantProps,
})